<template>
  <div class="container diy-page">
    <v-head></v-head>
    <v-left current="diy"></v-left>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="分类" name="category"></el-tab-pane>
        <el-tab-pane label="品牌" name="brand"></el-tab-pane>
        <el-tab-pane label="系列" name="series"></el-tab-pane>
        <el-tab-pane label="型号" name="model"></el-tab-pane>
        <el-tab-pane label="模板" name="templates"></el-tab-pane>
        <el-tab-pane label="模板2" name="templates_beautiful"></el-tab-pane>
        <el-tab-pane label="贴纸" name="sticker"></el-tab-pane>
        <el-tab-pane label="相框" name="photo_frame"></el-tab-pane>
        <el-tab-pane label="字体" name="font"></el-tab-pane>
        <!-- <el-tab-pane label="作品" name="share"></el-tab-pane> -->
        <!-- <el-tab-pane label="素材库" name="photo"></el-tab-pane> -->
      </el-tabs>
      <component :is="activeName"></component>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";

const category = (resolve) => require(["@/pages/diy/category/_list"], resolve);
const brand = (resolve) => require(["@/pages/diy/brand/_list"], resolve);
const series = (resolve) => require(["@/pages/diy/series/_list"], resolve);
const model = (resolve) => require(["@/pages/diy/model/_list"], resolve);
const model_spec = (resolve) => require(["@/pages/diy/model_spec/_list"], resolve);
const model_goods = (resolve) => require(["@/pages/diy/model_goods/_list"], resolve);
const templates = (resolve) => require(["@/pages/diy/templates/_list"], resolve);
const templates_beautiful = (resolve) => require(["@/pages/diy/templates/_list_beautiful"], resolve);
const sticker = (resolve) => require(["@/pages/diy/sticker/_list"], resolve);
const font = (resolve) => require(["@/pages/diy/font/_list"], resolve);
const share = (resolve) => require(["@/pages/diy/share/_list"], resolve);
const photo_frame = (resolve) => require(["@/pages/diy/photo_frame/_list"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    category,
    brand,
    series,
    model,
    model_goods,
    templates,
    sticker,
    font,
    photo_frame,
    share,
    templates_beautiful,
  },
  data() {
    return {
      activeName: "category",
    };
  },
  methods: {
    handleClick(e) {},
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/diy/Index.vue